<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增教程</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="list.length > 1 ? list.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回教程管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsTutarial'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in list" :key="index">
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <wcupload :option="{size:'large', phototype:'system'}" 
                        :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">教程分类<i>*</i></label>
                    <div class="TTL-tutarial-cate-inline">
                        <wcselect :option="{placeholder:'请选择分类',filterable:true,clearable:true,ischange:true,width:'170px'}" 
                            :value="item.cateid" 
                            :list="catelsits"
                            @finish="(val)=> {
                                if(val.type=='change') {
                                    item.cateid=val.value;
                                }
                            }"
                        />
                        <div class="TTL-tutarial-cate-inline-actions">
                            <span class="add-cate-title left10" @click.stop="openCateDialog">新增</span>
                            <span
                                class="add-cate-title left10"
                                :class="{ 'add-cate-title--disabled': cateRefreshLoading }"
                                @click.stop="GetCateList(true, true)"
                            >刷新</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">教程名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入教程名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                                
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                                
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">教程内容<i>*</i></label>
                    <div class="TTL-editors">
                    <QuillEditor
                        ref="myEditor"
                        :content="item.content"
                        :options="options"
                    />
                    </div>
                </el-form-item>

            </el-form>
        </div>
    </div>
    <TutarialCategoryPanel
        ref="catePanel"
        variant="dialogOnly"
        @categories-updated="onCategoriesUpdated"
    />
</div>
</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/Es/index';
import INTERFACE_MODEL_TUTARIAL from '@/Interface/Es/Tutarial';
import TutarialCategoryPanel from './components/TutarialCategoryPanel.vue';
import {QuillEditor} from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
export default {
    components:{QuillEditor, TutarialCategoryPanel},
    data() {
        return {
            Browser:'edittutarial',
            loadingobj:'edittutarial',
            limit:10,  //限制添加数据条数
            cateinfo:{thumb:'',cateid:'',name:'',content:''}, //教程信息               
            list:[], //数据
            templist:[],
            catelsits:[],
            cateRefreshLoading:false,
            fileobj:'',
            fileloading:false,
            options: {
                debug: 'info',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
                            ['blockquote', 'code-block'],                      //引用，代码块
                            [{ 'header': 1 }, { 'header': 2 }],               // 几级标题
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     // 有序列表，无序列表
                            [{ 'script': 'sub'}, { 'script': 'super' }],      // 下角标，上角标
                            [{ 'indent': '-1'}, { 'indent': '+1' }],          // 缩进
                            [{ 'direction': 'rtl' }],                         // 文字输入方向
                            [{ 'size': ['45px','60px','90px'] }],  // 字体大小
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
                            [{ 'color': [] }, { 'background': [] }],          // 颜色选择
                            [{ 'font': ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial'] }],// 字体
                            [{ 'align': [] }], // 居中
                            ['clean'],                                         // 清除样式
                            ['image']
                        ],
                        handlers: {
                            image: this.UploadImage
                        }
                    }
                },
                placeholder: '请输入内容',
                readOnly: false,
                theme: 'snow'
            }
        }
    },

    mounted() {
        this.OnloadMethod(); //页数初始化
    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetCateList(isfresh); //获取分类信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            var ids=data.param.ids;
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetTutarialInfos(ids);
                }).catch(()=> {

                });

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetTutarialInfos(ids);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.list.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个分类',type:'warning'});return false;}
            var data=[];
            this.list[0].content=this.GetContent(); //提取富文本内容
            for(var i in this.list) data.push(this.list[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_TUTARIAL.EDIT_TUTARIA({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'EsTutarial',delname:'EsEditTutarial'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作

        //获取教程信息列表
        GetTutarialInfos(ids) {
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_TUTARIAL.GET_TUTARIA_INFO({ids:ids}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.list=res.data;

                var _this=this;
                setTimeout(function() {
                    _this.SetContent(); //更新富文本信息
                },200);
            });
        },


        /** 填充富文本数据 **/
        SetContent() {
            this.$refs.myEditor[0].setHTML(this.list[0].content);
            this.cursorMove(); //光标移动
        },

        /** 获取富文本数据 **/
        GetContent() {
            var content=this.$refs.myEditor[0].getHTML();
            return content;
        },

        /** 富文本光标移动到最后 **/
        cursorMove() {
            var length=this.$refs.myEditor[0].getQuill().getLength();
            length++;
            this.$refs.myEditor[0].getQuill().setSelection(length);
            return length;
        },


        /** 上传图片 **/
        UploadImage() {
            this.uploadimages();
        },



        /** 上传文件 **/
        uploadimages() {
            var _this=this;
            var filelist=[];
            this.templist=[];                                 //重置临时图片数据
            var obj=document.querySelector('#TTLFilesmore');  //获取文件对象
            obj.click();                                      //点击触发上传图片
            obj.onchange=(e)=> {
                //提取文件并填充文件
                filelist=e.srcElement.files;
                for(var i in filelist) this.templist[i]=filelist[i];
                //清空已选的文件
                e.srcElement.value=null;     
                this.fileobj=setInterval(function() {
                    _this.uploadfile();
                },100);
            }
        },


        /** 执行上传文件操作 **/
        uploadfile() {
            //文件上传结束
            if(this.templist.length==0) {
                this.fileloading=false;
                clearInterval(this.fileobj); //关闭定时任务
                return false;
            }

            if(this.fileloading) return false; //正在执行上传操作
            this.fileloading=true; //上锁，标记操作正在执行

            var file=this.templist[0]; //提取待上传的文件
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:file}).then((res) => {
                    this.templist.splice(0,1);  //删除已上传的文件数据
                    this.fileloading=false;  //开关释放                 
                    if(res.status > 0) return false;
                    //提取上传成功的图片
                    var url=process.env.VUE_APP_IMAGE_ADDRESS+res.data.url;
                    //调整光标到最后
                    var index=this.cursorMove();
                    this.$refs.myEditor[0].getQuill().insertEmbed(index, 'image', url);
                    //调整光标到最后
                    this.cursorMove();
            });
        },


        /** 获取分类信息 **/
        GetCateList(isfresh, showNotice) {
            this.cateRefreshLoading = true;
            this.$method.GET_TUTARIAL_CATES(!!isfresh).then((res) => {
                this.catelsits = res || [];
                this.cateRefreshLoading = false;
                if (showNotice) this.$notice({ title: '成功', message: '分类列表已刷新', type: 'success' });
            }).catch(() => {
                this.cateRefreshLoading = false;
            });
        },
        openCateDialog() {
            if (this.$refs.catePanel) this.$refs.catePanel.openDialog();
        },
        onCategoriesUpdated() {
            this.GetCateList(true);
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
.TTL-editors {display: inline-block;width:60%;}
.TTL-tutarial-cate-inline {
    display: inline-flex;
    align-items: center;
}
.TTL-tutarial-cate-inline-actions {
    display: inline-flex;
    align-items: center;
}
.add-cate-title {
    font-size: 13px;
    color: #666eeb;
    cursor: pointer;
}
.add-cate-title:hover { text-decoration: underline; }
.add-cate-title.add-cate-title--disabled {
    color: #999;
    cursor: not-allowed;
}
</style>